import { BaseFetch } from "../main-model"
export default class SchoolGroupModel extends BaseFetch {
    getSchoolGroupBy = (data) =>
    this.authFetch({
      url: "school-group/getSchoolGroupBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getSchoolGroupById = (data) =>
    this.authFetch({
      url: "school-group/getSchoolGroupById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateSchoolGroupById = (data) =>
    this.authFetch({
      url: "school-group/updateSchoolGroupById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertSchoolGroup = (data) =>
    this.authFetch({
      url: "school-group/insertSchoolGroup",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteSchoolGroupById = (data) =>
    this.authFetch({
      url: "school-group/deleteSchoolGroupById",
      method: "POST",
      body: JSON.stringify(data),
    })
    getSchoolGroupBySchool = (data) =>
    this.authFetch({
      url: "school-group/getSchoolGroupBySchool",
      method: "POST",
      body: JSON.stringify(data),
    })
}
